import { Card } from "@/components/admin/card";
import { AdminIcon } from "@/components/admin/icon";
import { PageHead } from "@/components/admin/page-head";

/**
 * Fournisseurs & cautions — module à venir.
 *
 * Cette page affichait quarante partenaires, vingt-quatre millions de francs de
 * cautions et deux alertes de seuil : tout était écrit en dur dans le code, et
 * aucun de ces chiffres ne venait du serveur. Un responsable achats pouvait s'y
 * fier de bonne foi et engager un enlèvement sur une caution imaginaire.
 *
 * Aucune contrepartie n'existe côté API : il n'y a donc rien à brancher, et
 * inventer des données en attendant coûte plus cher que de ne rien afficher.
 * La page annonce désormais franchement ce qu'elle est.
 */
export function AdminSuppliersPage() {
	return (
		<>
			<PageHead
				title="Fournisseurs & cautions"
				sub="Suivi des partenaires, des cautions déposées et des encours d'enlèvement"
			/>

			<Card>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: 14,
						padding: "56px 24px",
						textAlign: "center",
					}}
				>
					<div
						style={{
							width: 44,
							height: 44,
							borderRadius: 10,
							display: "grid",
							placeItems: "center",
							background: "var(--a-surface-2, rgba(30,77,59,.08))",
							color: "var(--a-ink-mute)",
						}}
					>
						<AdminIcon n="factory" s={20} />
					</div>

					<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
						<h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
							Le suivi des fournisseurs n'est pas encore ouvert
						</h3>
						<p
							style={{
								margin: 0,
								maxWidth: 460,
								fontSize: 13,
								lineHeight: 1.55,
								color: "var(--a-ink-mute)",
							}}
						>
							Les cautions, les encours d'enlèvement et les règlements du
							vendredi seront gérés depuis cet écran. En attendant, ils se
							suivent hors application.
						</p>
					</div>
				</div>
			</Card>
		</>
	);
}
